import {
  changeOrderNotRefUrl,
  createOrderNotRefUrl
} from "@saleor/createOrChangeNotRefContract/urls";
import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

export enum ContractListUrlSortField {
  contractNo = "contractNo"
}

export type ContractListUrlSort = Sort<ContractListUrlSortField>;

export enum ContracDetailSortField {
  remain = "remain",
  total = "total",
  price = "price"
}

export enum OrderDetailSortField {
  remain = "remain",
  total = "total",
  price = "price",
  contract = "contract"
}

export type ContracDetailUrlSort = Sort<ContracDetailSortField>;

export enum CartDetailSortField {
  linesCount = "linesCount"
}

export enum CartDetailCustomerSortField {
  linesCount = "linesCount"
}

export enum PreviewOrderSortField {
  ITEM_NO = "ITEM_NO"
}

export enum SalesOrderSortListField {
  createDate = "createDate",
  poNo = "poNo",
  reqDeliveryDate = "reqDeliveryDate",
  orderNo = "orderNo"
}

export type CartDetailUrlSort = Sort<CartDetailSortField>;
export type CartDetailCustomerUrlSort = Sort<CartDetailCustomerSortField>;
export type OrderDetailUrlSort = Sort<OrderDetailSortField>;
export type PreviewOrderSort = Sort<PreviewOrderSortField>;

export type CreateOrderUrlQueryParams = Pagination & ContractListUrlSort;
export type ContracDetailQueryParams = Pagination & ContracDetailUrlSort;
export type OrderDetailQueryParams = Pagination & OrderDetailUrlSort;
export type CartQueryParams = Pagination & CartDetailUrlSort;
export type CartCustomerQueryParams = Pagination & CartDetailCustomerUrlSort;
export type PreviewOrderQueryParam = Pagination & PreviewOrderSort;

export const createOrderUrl = "/sold-to";
export const contractDetailSection = `${createOrderUrl}/contract`;
export const shoppingCart = `${createOrderUrl}/shopping-cart`;
export const orderCart = `${createOrderUrl}/create-order`;
export const orderProcessing = `${createOrderUrl}/order-processing`;
export const previewOrderUrl = `${createOrderUrl}/preview-order`;

export const draftOrder = "/save-draft";

export const createOrderUrlParam = (id: string) => (
  params?: CreateOrderUrlQueryParams
): string => {
  if (params === undefined) {
    return contractUrl(id);
  } else {
    return contractUrl(id, params);
  }
};
export const contractPath = (id: string) => urlJoin(createOrderUrl, id);

export const previewOrderPath = (id: string) => urlJoin(previewOrderUrl, id);

export const contractDetailPath = (id: string) =>
  urlJoin(contractDetailSection, id);

export const orderPath = (id: string) => urlJoin(shoppingCart, id);

export const contractUrl = (id: string, params?: any) =>
  contractPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const contractDetailUrl = (id: string, params?: any) =>
  contractDetailPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const orderDetailUrl = (id: string, params?: any) =>
  orderPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
export const orderCartPath = (id: string) =>
  id === ":id"
    ? urlJoin(orderCart, id)
    : urlJoin(orderCart, id) + "?" + stringifyQs({ enabledCreate: "true" });

export const getNotRefDraftOrderPath = (id: string) =>
  !!id
    ? urlJoin(createOrderNotRefUrl, encodeURIComponent(id))
    : createOrderNotRefUrl;

export const notRefOrderPath = (id?: string, soNo?: string) =>
  urlJoin(createOrderNotRefUrl, id, soNo);
export const notRefChangeOrderPath = (id?: string, soNo?: string) =>
  urlJoin(changeOrderNotRefUrl, id, soNo);

export const orderCartlUrl = (id: string, params?: any) =>
  orderCartPath(encodeURIComponent(id)) + "&" + stringifyQs(params);
export const contractDetaiUrlParam = (id: string) => (
  params?: ContracDetailQueryParams
): string => {
  if (params === undefined) {
    return contractDetailUrl(id);
  } else {
    return contractDetailUrl(id, params);
  }
};
export const orderDetailUrlParam = (id: string) => (
  params?: OrderDetailQueryParams
): string => {
  if (params === undefined) {
    return orderDetailUrl(id);
  } else {
    return orderDetailUrl(id, params);
  }
};
export const cartListUrl = (params?: CartQueryParams) =>
  shoppingCart + "?" + stringifyQs(params);
export const cartCustomerListUrl = (params?: CartCustomerQueryParams) =>
  shoppingCart + "?" + stringifyQs(params);

export const previewOrderListUrl = (id, params?: PreviewOrderQueryParam) =>
  previewOrderPath(id) + "?" + stringifyQs(params);
